<template>
  <div>
    <div class="container">
      <div class="big">
        <Box
          title="GetTheApp"
          subtitle="GetTheAppSubtitle"
          :points="points.big"
          :img="require('@/assets/images/phone.png')"
        />
      </div>

      <div class="column">
        <div class="row">
          <div class="small">
            <Box
              title="AccumulativeAccount"
              subtitle="AccumulativeAccountSubtitle"
              :points="points.small1"
            />
          </div>
          <div class="small">
            <Box
              :title="$screen.width > 768 ? 'FastWithdrawal' : 'MiningPool'"
              :subtitle="
                $screen.width > 768
                  ? 'FastWithdrawalSubtitle'
                  : 'MiningPoolSubtitle'
              "
              :points="points[$screen.width > 768 ? 'small2' : 'medium']"
              :img="require('@/assets/images/sim.png')"
              img-position="right bottom"
              img-size="50%"
            />
          </div>
        </div>
        <div class="row">
          <div class="medium">
            <Box
              :title="$screen.width <= 768 ? 'FastWithdrawal' : 'MiningPool'"
              :subtitle="
                $screen.width <= 768
                  ? 'FastWithdrawalSubtitle'
                  : 'MiningPoolSubtitle'
              "
              :points="points[$screen.width <= 768 ? 'small2' : 'medium']"
              :img="require('@/assets/images/pool.png')"
              img-position="right bottom"
              img-size="50%"
            />
          </div>
          <div class="extraSmall">
            <Box
              title="TrustedByOverClients"
              :options="{ number: '300,000' }"
            />
          </div>
        </div>
      </div>
    </div>
    <Banner class="mx-auto max-w-[1200px] my-2" />
  </div>
</template>

<script>
import Box from "./Box.vue";
import { Banner } from "@/features";

export default {
  name: "GridLayout",
  components: { Box, Banner },
  data() {
    return {
      points: {
        big: [
          {
            id: 1,
            title: "X_Million",
            subtitle: "TransactionsPerMonth",
            options: { number: "2.7" },
          },
          {
            id: 2,
            title: "X_Year",
            subtitle: "OfStableAppPerformance",
            options: { number: "6" },
          },
        ],
        small1: [
          {
            id: 1,
            title: "14%",
            subtitle: "UpToAnnually",
          },
        ],
        small2: [
          {
            id: 1,
            title: "16",
            subtitle: "AvailableCurrencies",
          },
        ],
        medium: [
          {
            id: 1,
            title: "1.5%",
            subtitle: "FeeStartingFrom",
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
$container-width: 1200;
$gap-px: 10;
$right-col-width: (690 / $container-width) * 100%;
$big-box-width: (692 / $container-width) * 100%;
$small-box-width: (340 / 690) * 100%;
$medium-box-width: (450 / 690) * 100%;
$extra-small-box-width: (230 / 690) * 100%;

.container {
  display: flex;
  margin: 0 auto;
  gap: $gap-px + px;
  max-width: $container-width + px;
  min-height: 450px;
  flex: 1;
}

.column {
  display: flex;
  flex-direction: column;
  width: $right-col-width;
  gap: $gap-px + px;
  flex: 1;
}

.row {
  display: flex;
  gap: $gap-px + px;
  flex: 1;
}

.big {
  width: $big-box-width;
  min-height: 450px;
}

.small {
  width: $small-box-width;
}

.medium {
  width: $medium-box-width;
}

.extraSmall {
  width: $extra-small-box-width;
}

@media (max-width: 1024px) {
  .container {
    flex-direction: column;
    gap: $gap-px + px;
  }
  .row {
    flex-direction: row;
    gap: $gap-px + px;
  }
  .big {
    height: 450px;
    width: 100%;
  }

  .column,
  .row {
    width: 100%;
  }

  .small,
  .medium,
  .extraSmall {
    height: 235px;
  }
}

@media (max-width: 768px) {
  .row {
    flex-direction: column;
  }

  .big {
    height: 650px;
  }

  .small,
  .medium,
  .extraSmall {
    width: 100%;
    height: 235px;
  }
}
</style>
